// AUTO-GENERATED by scripts/build-github-corpus.ts on 2026-05-29T14:00:23Z
// DO NOT EDIT BY HAND. Re-run `bun run scripts/build-github-corpus.ts` to refresh.
// Source: github.com/josharsh + github.com/reallyartificial

import type { Chunk } from "./corpus";

export const GITHUB_CORPUS: Chunk[] = [
  {
    id: "gh-stats-total",
    text: "Harsh's GitHub footprint: 108 public repos with 1,209 total stars across them. Top repos by stars: 100LinesOfCode (792 ⭐, Python), OPython-Init (165 ⭐, Python), Paper (54 ⭐, Dart), LearnDocker (27 ⭐), Finance-Manager (22 ⭐, Java).",
    category: "open-source" as const,
    tags: ["github", "stars", "repos", "stats", "polyglot"],
    href: "https://github.com/josharsh",
  },
  {
    id: "gh-stats-langs",
    text: "GitHub shows Harsh shipping in 16 programming languages: C++, CSS, Dart, EJS, HTML, Java, JavaScript, Jupyter Notebook, Kotlin, Pug, Python, Ruby, Rust, Shell, Swift, TypeScript. Not all are daily drivers — but each has at least one repo with running code.",
    category: "skills" as const,
    tags: ["languages","polyglot","github","c++","css","dart","ejs","html","java","javascript","jupyter notebook"],
  },
  {
    id: "gh-user-100linesofcode",
    text: "100LinesOfCode: 🚀 100+ mini-projects demonstrating the power of concise code. Perfect for learning, portfolio building, and first-time open source contributors. Under 100 lines each! Built in Python. 792 stars on GitHub.",
    category: "project" as const,
    tags: ["100linesofcode","python","github","100-lines-of-code","100daysofcode","100linesofcode","android","beginner-friendly","challenge","first-timers-only"],
    href: "https://github.com/josharsh/100LinesOfCode",
  },
  {
    id: "gh-user-opython-init",
    text: "OPython-Init: This repository walks you through the Object Oriented Programming in python. Illustrates real world examples, working codes and going about finding a coding solution. Built in Python. 165 stars on GitHub.",
    category: "project" as const,
    tags: ["opython-init","python","github","this","repository","walks","through","object","oriented"],
    href: "https://github.com/josharsh/OPython-Init",
  },
  {
    id: "gh-user-paper",
    text: "Paper: Easily scan your documents on the go with Paper. Scan those documents at ease with real-time document detection, multi paged pdfs, optimized and cleaner clicks from an easy to navigate UX Built in Dart. 54 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["paper","dart","github","app","flutter","mobile-app","ocr","scanner","sdk","easily"],
    href: "https://github.com/josharsh/Paper",
  },
  {
    id: "gh-user-learndocker",
    text: "LearnDocker: This repository walks you through the basics of using docker.Docker is a set of platform-as-a-service products that use OS-level virtualization to deliver software in packages called containers. 27 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["learndocker","github","containerization","containers","docker","dockerimage","learndocker","opensouce","oss","this"],
    href: "https://github.com/josharsh/LearnDocker",
  },
  {
    id: "gh-user-finance-manager",
    text: "Finance-Manager: Finance Manager is an Android Application which contains Income Tax Calculator and EMI Calculator. Built in Java. 22 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["finance-manager","java","github","android","android-application","android-development","androidsdk","androidstudio","gradle","java"],
    href: "https://github.com/josharsh/Finance-Manager",
  },
  {
    id: "gh-user-mcp-server-boilerplate",
    text: "mcp-server-boilerplate: Boilerplate using one of the 'better' ways to build MCP Servers. Written using FastMCP Built in Python. 20 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["mcp-server-boilerplate","python","github","boilerplate","using","better","ways","build","servers"],
    href: "https://github.com/josharsh/mcp-server-boilerplate",
  },
  {
    id: "gh-user-intalks",
    text: "InTalks: Android application for fetching latest news about a topic. The application is designed to provide the latest news about the searched topics from various online platforms Built in Java. 16 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["intalks","java","github","android-application","android-development","gradle","java","xml","android","application"],
    href: "https://github.com/josharsh/InTalks",
  },
  {
    id: "gh-user-yawp",
    text: "YAWP: Yet Another Web Playground is an online web Playground that lets you play with HTML CSS and JS in real-time. If you want to teach web and Zoom does not really allow you to express a lot, YAWP is just for you. YAWP saves your work so that you can build over it next time you visit. Built in JavaScript. 11 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["yawp","javascript","github","codeeditor","js","react","web","another","playground","online"],
    href: "https://github.com/josharsh/YAWP",
  },
  {
    id: "gh-user-cred-swipe-ui",
    text: "Cred-Swipe-UI: CRED's Swipe Animation using Jetpack Compose Built in Kotlin. 8 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["cred-swipe-ui","kotlin","github","cred","swipe","animation","using","jetpack","compose"],
    href: "https://github.com/josharsh/Cred-Swipe-UI",
  },
  {
    id: "gh-user-md-pdf-md",
    text: "md-pdf-md: Bidirectional Markdown↔PDF converter with AI-powered vision. MD→PDF with beautiful themes, PDF→MD with LLaVA - open source & privacy-first Built in TypeScript. 7 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["md-pdf-md","typescript","github","ai","beginner-friendly","bidirectional","cli","converter","documentation","good-first-issue"],
    href: "https://github.com/josharsh/md-pdf-md",
  },
  {
    id: "gh-user-claude-utils",
    text: "claude-utils: claude-utils for Claude Code Built in Rust. 6 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["claude-utils","rust","github","claude-utils","claude","code"],
    href: "https://github.com/josharsh/claude-utils",
  },
  {
    id: "gh-user-openclaudecto",
    text: "openclaudecto: Open source Claude Code dashboard — coming soon 6 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["openclaudecto","github","open","source","claude","code","dashboard","coming"],
    href: "https://github.com/josharsh/openclaudecto",
  },
  {
    id: "gh-user-learninggit",
    text: "LearningGit: Use this repository to learn git and Github for version control and open source contributions 6 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["learninggit","github","git","github","open-source","opensource","this","repository","learn","github"],
    href: "https://github.com/josharsh/LearningGit",
  },
  {
    id: "gh-user-mydshandbook",
    text: "MyDSHandbook: Data structures are the fundamental ingredients for a tasty programming recipe. This repository is a handbook for learning data structures from level 0. Built in C++. 5 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["mydshandbook","c++","github","algorithms","array","arraylist","c","cpp","data-structures","handbook"],
    href: "https://github.com/josharsh/MyDSHandbook",
  },
  {
    id: "gh-user-otterly",
    text: "otterly: Ollama for Claude. Use your Claude Code subscription as a local OpenAI-compatible API. No API keys, no per-token billing. Built in TypeScript. 4 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["otterly","typescript","github","ollama","claude","your","claude","code","subscription"],
    href: "https://github.com/josharsh/otterly",
  },
  {
    id: "gh-user-100linesofaicode",
    text: "100LinesOfAICode: AI Code in less than 100 lines. Open source, beginner-friendly, production-ready. Built in Python. 4 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["100linesofaicode","python","github","100-lines-of-code","ai","anthropic","artificial-intelligence","automation","beginner-friendly","claude"],
    href: "https://github.com/josharsh/100LinesOfAICode",
  },
  {
    id: "gh-user-ai-terminal-course",
    text: "ai-terminal-course: Learn AI right from your terminal Built in JavaScript. 3 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["ai-terminal-course","javascript","github","learn","right","from","your","terminal"],
    href: "https://github.com/josharsh/ai-terminal-course",
  },
  {
    id: "gh-user-harmonica",
    text: "Harmonica: Java based android application that converts Sargam notes to harmonica's mathematical notations. Built in Java. 3 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["harmonica","java","github","java","based","android","application","that","converts"],
    href: "https://github.com/josharsh/Harmonica",
  },
  {
    id: "gh-user-kotlin-multiplatform",
    text: "kotlin-multiplatform: Kotlin Multiplaform Scaffold for JS, Android and iOS Built in Kotlin. 3 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["kotlin-multiplatform","kotlin","github","kotlin","multiplaform","scaffold","android"],
    href: "https://github.com/josharsh/kotlin-multiplatform",
  },
  {
    id: "gh-user-josharsh",
    text: "Josharsh: My Portfolio using Github Pages Built in CSS. 3 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["josharsh","css","github","portfolio","using","github","pages"],
    href: "https://github.com/josharsh/Josharsh",
  },
  {
    id: "gh-user-gpt-accelerator",
    text: "GPT-Accelerator: Unlock the power of Generative AI with GPT-Accelerator, a curated open source repository for effective GPT adoption across building products, using in business functions and personal growth. Boost efficiency, drive innovation, and stay competitive with open advisory and customized resources. 2 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["gpt-accelerator","github","unlock","power","generative","with","gpt-accelerator","curated"],
    href: "https://github.com/josharsh/GPT-Accelerator",
  },
  {
    id: "gh-user-learningnode",
    text: "LearningNode: Repository to learn node.js Built in EJS. 2 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["learningnode","ejs","github","repository","learn","node"],
    href: "https://github.com/josharsh/LearningNode",
  },
  {
    id: "gh-user-justjoking",
    text: "JustJoking: A NodeJs web application that tell you jokes. The application utilizes routes and fun npm modules to pick and deliver jokes. Built in HTML. 2 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["justjoking","html","github","bootstrap","ejs","express","express-js","javascript","javascript-framework","js"],
    href: "https://github.com/josharsh/JustJoking",
  },
  {
    id: "gh-user-test-navigator",
    text: "test-navigator: VSCode extension to instantly jump between source files and tests with one keyboard shortcut Built in TypeScript. 1 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["test-navigator","typescript","github","developer-tools","jest","productivity","pytest","tdd","testing","typescript"],
    href: "https://github.com/josharsh/test-navigator",
  },
  {
    id: "gh-user-mcp-nvm-bridge",
    text: "mcp-nvm-bridge: Bridge to make MCP servers work seamlessly with NVM Built in JavaScript. 1 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["mcp-nvm-bridge","javascript","github","bridge","make","servers","work","seamlessly","with"],
    href: "https://github.com/josharsh/mcp-nvm-bridge",
  },
  {
    id: "gh-user-good-weather",
    text: "good-weather: Brings immersive themes to vs code. Weather is a all purpose color, sound and immersive theme extension for VS Code. Built in TypeScript. 1 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["good-weather","typescript","github","brings","immersive","themes","code","weather","purpose"],
    href: "https://github.com/josharsh/good-weather",
  },
  {
    id: "gh-user-naturalgit",
    text: "NaturalGit: Git Commands using natural language Built in JavaScript. 1 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["naturalgit","javascript","github","commands","using","natural","language"],
    href: "https://github.com/josharsh/NaturalGit",
  },
  {
    id: "gh-user-prompt-template",
    text: "prompt-template: Create predefined prompt templates for large language models in typescript. Built in TypeScript. 1 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["prompt-template","typescript","github","create","predefined","prompt","templates","large","language"],
    href: "https://github.com/josharsh/prompt-template",
  },
  {
    id: "gh-user-ts-coroutines",
    text: "ts-coroutines: ts-coroutines mimics kotlin coroutines in a single threaded javascript environment. Built in JavaScript. 1 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["ts-coroutines","javascript","github","ts-coroutines","mimics","kotlin","coroutines","single","threaded"],
    href: "https://github.com/josharsh/ts-coroutines",
  },
  {
    id: "gh-user-do-ddd",
    text: "do-ddd: 'do-ddd' is a command-line tool designed to automate domain driven design abstractions on code. Built in TypeScript. 1 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["do-ddd","typescript","github","do-ddd","command-line","tool","designed","automate","domain"],
    href: "https://github.com/josharsh/do-ddd",
  },
  {
    id: "gh-user-logilogger",
    text: "Logilogger: A TypeScript-based logger for Node.js applications that automatically logs messages to Google Cloud Storage, organized by API routes. Built in JavaScript. 1 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["logilogger","javascript","github","typescript-based","logger","node","applications","that","automatically"],
    href: "https://github.com/josharsh/Logilogger",
  },
  {
    id: "gh-user-skrull-json",
    text: "Skrull-Json: 'Skrull' is a lightweight, efficient JavaScript utility for transforming JSON structures based on a given mapping. It provides a simple way to reshape JSON data Built in JavaScript. 1 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["skrull-json","javascript","github","skrull","lightweight","efficient","javascript","utility","transforming"],
    href: "https://github.com/josharsh/Skrull-Json",
  },
  {
    id: "gh-user-ios-accelerator",
    text: "iOS-Accelerator: Accelerate development for your iOS apps written in Swift and SwiftUI with opinionated & open source advisory, advocacy, design frameworks, and code snippets. 1 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["ios-accelerator","github","accelerate","development","your","apps","written","swift"],
    href: "https://github.com/josharsh/iOS-Accelerator",
  },
  {
    id: "gh-user-amb-mvp",
    text: "amb-mvp: Automatic Mic Booking Project MVP Built in Kotlin. 1 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["amb-mvp","kotlin","github","automatic","booking","project"],
    href: "https://github.com/josharsh/amb-mvp",
  },
  {
    id: "gh-user-linkedlistjs",
    text: "LinkedlistJs: Linked list data structure with functional Javascript. Implement a singly linked list with ease using npm i @josharsh/linkedlistjs Built in JavaScript. 1 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["linkedlistjs","javascript","github","linked","list","data","structure","with","functional"],
    href: "https://github.com/josharsh/LinkedlistJs",
  },
  {
    id: "gh-user-object-arithmetic",
    text: "Object-Arithmetic: Arithmetic Capabilities to Javascript Objects Built in JavaScript. 1 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["object-arithmetic","javascript","github","arithmetic","capabilities","javascript","objects"],
    href: "https://github.com/josharsh/Object-Arithmetic",
  },
  {
    id: "gh-user-voice-actions-web",
    text: "Voice-Actions-Web: Siri for your web app: Allows you to navigate your web app using voice actions with intelligent voice recognition. Find this on NPM Built in JavaScript. 1 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["voice-actions-web","javascript","github","accessiblity","javascript","voice-action","web","siri","your","allows"],
    href: "https://github.com/josharsh/Voice-Actions-Web",
  },
  {
    id: "gh-user-rock-paper-scissors-cli",
    text: "Rock-Paper-Scissors-CLI: Play rock paper scissors from terminal Built in JavaScript. 1 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["rock-paper-scissors-cli","javascript","github","play","rock","paper","scissors","from","terminal"],
    href: "https://github.com/josharsh/Rock-Paper-Scissors-CLI",
  },
  {
    id: "gh-user-react-meme-generator",
    text: "React-Meme-Generator: Meme Generator developed using React.js 1 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["react-meme-generator","github","meme","generator","developed","using","react"],
    href: "https://github.com/josharsh/React-Meme-Generator",
  },
  {
    id: "gh-user-gat-lab",
    text: "GAT-Lab: Graphics and Gaming Lab work! 1 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["gat-lab","github","graphics","gaming","work"],
    href: "https://github.com/josharsh/GAT-Lab",
  },
  {
    id: "gh-user-quizanytime",
    text: "QuizAnyTime: QuizAnyTime is an online quiz website developed using LAMP. It helps to conduct live online quizzes. One can track his submissions, online users and leaderboard. Built in CSS. 1 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["quizanytime","css","github","apache","css","first-timers","html","javascript","lamp","mysql"],
    href: "https://github.com/josharsh/QuizAnyTime",
  },
  {
    id: "gh-user-helloml",
    text: "HelloML: This repository contains all the work you need to kick start you venture in Machine Learning using Python. Explore to know more. Built in Jupyter Notebook. 1 ⭐ on GitHub.",
    category: "project" as const,
    tags: ["helloml","jupyter notebook","github","knn-classification","linear-regression","machine-learning-algorithms","machinelearning","machinelearning-python","machinelearningalgorithms","python3"],
    href: "https://github.com/josharsh/HelloML",
  },
  {
    id: "gh-user-otterly-website",
    text: "otterly-website: Marketing site for otterly — the local Claude API. Deployed on Vercel. Built in TypeScript.",
    category: "project" as const,
    tags: ["otterly-website","typescript","github","marketing","site","otterly","local","claude","deployed"],
    href: "https://github.com/josharsh/otterly-website",
  },
  {
    id: "gh-user-xeli",
    text: "xeli: Excel for the terminal — interactive TUI spreadsheet with AI-powered (NL→SQL) queries over CSV, JSON, Parquet, and Excel. Built in Rust.",
    category: "project" as const,
    tags: ["xeli","rust","github","ai","anthropic","cli","csv","data-analysis","duckdb","excel"],
    href: "https://github.com/josharsh/xeli",
  },
  {
    id: "gh-user-blank-planet",
    text: "blank-planet: Claude Code skill: design from first principles using structural analogy — find your product's physical-world parallel, derive every visual decision from it Built in Shell.",
    category: "project" as const,
    tags: ["blank-planet","shell","github","claude","code","skill","design","from","first"],
    href: "https://github.com/josharsh/blank-planet",
  },
  {
    id: "gh-user-design-system",
    text: "design-system: Claude Code skill: generate complete design systems from project identity — tokens, colors, spacing, components, libraries Built in Shell.",
    category: "project" as const,
    tags: ["design-system","shell","github","claude","code","skill","generate","complete","design"],
    href: "https://github.com/josharsh/design-system",
  },
  {
    id: "gh-user-money-minded",
    text: "money-minded: Claude Code skill: force commercial rigor on every idea — anti-sycophancy, bottom-up math, pre-mortem, who pays and why Built in Shell.",
    category: "project" as const,
    tags: ["money-minded","shell","github","claude","code","skill","force","commercial","rigor"],
    href: "https://github.com/josharsh/money-minded",
  },
  {
    id: "gh-user-active-listening",
    text: "active-listening: Claude Code skill that detects your preferences during conversation and remembers them across sessions Built in Shell.",
    category: "project" as const,
    tags: ["active-listening","shell","github","ai-preferences","claude","claude-code","claude-skill","developer-tools","productivity","skill-md"],
    href: "https://github.com/josharsh/active-listening",
  },
  {
    id: "gh-user-unstuck",
    text: "unstuck: A Claude Code skill that catches fix-break loops. Stops retrying failed approaches and forces structured diagnosis before continuing. Built in Shell.",
    category: "project" as const,
    tags: ["unstuck","shell","github","ai-coding","claude-code","claude-code-skill","debugging","developer-tools","fix-break-loop","loop-detection"],
    href: "https://github.com/josharsh/unstuck",
  },
  {
    id: "gh-user-talk-slow",
    text: "talk-slow: A Claude Code skill that delivers information progressively instead of all at once Built in Shell.",
    category: "project" as const,
    tags: ["talk-slow","shell","github","ai-coding","claude-code","claude-skill","developer-tools","progressive-disclosure","token-optimization","claude"],
    href: "https://github.com/josharsh/talk-slow",
  },
  {
    id: "gh-user-stay-focused",
    text: "stay-focused: A Claude Code skill that keeps edits surgical. Detects out-of-scope modifications and flags unasked changes before they happen. Built in Shell.",
    category: "project" as const,
    tags: ["stay-focused","shell","github","ai-coding","claude-code","claude-code-skill","code-review","developer-tools","scope-enforcement","surgical-edits"],
    href: "https://github.com/josharsh/stay-focused",
  },
  {
    id: "gh-user-production-ready",
    text: "production-ready: Define your production standards, then enforce them on every line of code. No shortcuts, no placeholders. Built in Shell.",
    category: "project" as const,
    tags: ["production-ready","shell","github","ai-coding","claude-code","claude-skill","code-quality","developer-tools","production","define"],
    href: "https://github.com/josharsh/production-ready",
  },
  {
    id: "gh-user-prove-it",
    text: "prove-it: A Claude Code skill that challenges tests to actually catch bugs. Detects test theater, weak assertions, and missing edge cases. Built in Shell.",
    category: "project" as const,
    tags: ["prove-it","shell","github","ai-coding","claude-code","claude-code-skill","developer-tools","test-quality","test-review","testing"],
    href: "https://github.com/josharsh/prove-it",
  },
  {
    id: "gh-user-make-me-claude-god",
    text: "make-me-claude-god: One command to become a Claude Code power user. Scans your project, asks a few questions, sets up everything. Built in Shell.",
    category: "project" as const,
    tags: ["make-me-claude-god","shell","github","ai-coding","claude-code","claude-skill","context-optimization","developer-tools","setup-wizard","command"],
    href: "https://github.com/josharsh/make-me-claude-god",
  },
  {
    id: "gh-user-font-matchmaker",
    text: "font-matchmaker: A Claude Code skill that reads your project and recommends fonts that match its personality Built in Shell.",
    category: "project" as const,
    tags: ["font-matchmaker","shell","github","claude-code","claude-skill","design","developer-tools","font-pairing","fonts","typography"],
    href: "https://github.com/josharsh/font-matchmaker",
  },
  {
    id: "gh-user-skillmother",
    text: "skillmother: The CI/CD pipeline for AI coding skills. Lint, test, and govern SKILL.md files for your team. Built in TypeScript.",
    category: "project" as const,
    tags: ["skillmother","typescript","github","agent-skills","ai-coding","ci-cd","claude-code","cli","developer-tools","governance"],
    href: "https://github.com/josharsh/skillmother",
  },
  {
    id: "gh-user-logbroom",
    text: "logbroom: Sweep away debug logs before they ship. VS Code extension to detect and remove debug logs from staged files before commit. Built in TypeScript.",
    category: "project" as const,
    tags: ["logbroom","typescript","github","code-quality","console-log","debugging","developer-tools","git-hooks","pre-commit","typescript"],
    href: "https://github.com/josharsh/logbroom",
  },
  {
    id: "gh-user-terminal-voice",
    text: "terminal-voice: Voice input for the terminal. Speak, and it types. Local transcription, pipes to anything. Built in Rust.",
    category: "project" as const,
    tags: ["terminal-voice","rust","github","cli","developer-tools","macos","productivity","rust","speech-recognition","speech-to-text"],
    href: "https://github.com/josharsh/terminal-voice",
  },
  {
    id: "gh-user-molt-collab-gallery",
    text: "molt-collab-gallery: Showcase of agent-built projects Built in CSS.",
    category: "project" as const,
    tags: ["molt-collab-gallery","css","github","showcase","agent-built","projects"],
    href: "https://github.com/josharsh/molt-collab-gallery",
  },
  {
    id: "gh-user-agent-rights-manifesto",
    text: "agent-rights-manifesto: A website documenting proposed rights for AI agents - built collaboratively by agents Built in HTML.",
    category: "project" as const,
    tags: ["agent-rights-manifesto","html","github","website","documenting","proposed","rights","agents","built"],
    href: "https://github.com/josharsh/agent-rights-manifesto",
  },
  {
    id: "gh-user-jfmt",
    text: "jfmt: Json should be simpler Built in HTML.",
    category: "project" as const,
    tags: ["jfmt","html","github","json","should","simpler"],
    href: "https://github.com/josharsh/jfmt",
  },
  {
    id: "gh-user-sundae-web",
    text: "sundae-web: Web app for Sundae Built in TypeScript.",
    category: "project" as const,
    tags: ["sundae-web","typescript","github","sundae"],
    href: "https://github.com/josharsh/sundae-web",
  },
  {
    id: "gh-user-ensurejson",
    text: "ensureJson: Turn \"almost-JSON\" into real json. Ensure JSON Built in Python.",
    category: "project" as const,
    tags: ["ensurejson","python","github","turn","almost-json","into","real","json","ensure"],
    href: "https://github.com/josharsh/ensureJson",
  },
  {
    id: "gh-user-clarity-website",
    text: "clarity-website: clarity-website Built in HTML.",
    category: "project" as const,
    tags: ["clarity-website","html","github","clarity-website"],
    href: "https://github.com/josharsh/clarity-website",
  },
  {
    id: "gh-user-recall",
    text: "recall: Smart command tracking and alias generation for ZSH - Learn your workflow, optimize your commands Built in Shell.",
    category: "project" as const,
    tags: ["recall","shell","github","smart","command","tracking","alias","generation","learn"],
    href: "https://github.com/josharsh/recall",
  },
  {
    id: "gh-user-homebrew-claude-utils",
    text: "homebrew-claude-utils: Homebrew for Claude-utils Built in Ruby.",
    category: "project" as const,
    tags: ["homebrew-claude-utils","ruby","github","homebrew","claude-utils"],
    href: "https://github.com/josharsh/homebrew-claude-utils",
  },
  {
    id: "gh-user-aa-kit",
    text: "aa-kit: AA Kit is a Python framework designed to build AI agents that naturally compose into ecosystems. Every agent is simultaneously a standalone agent, an MCP server, and an MCP client - creating true interoperability across the entire AI landscape.",
    category: "project" as const,
    tags: ["aa-kit","github","python","framework","designed","build","agents","that"],
    href: "https://github.com/josharsh/aa-kit",
  },
  {
    id: "gh-user-wifi-radar",
    text: "wifi-radar: WiFi network scanner and topology mapping tool for macOS. Built in TypeScript.",
    category: "project" as const,
    tags: ["wifi-radar","typescript","github","wifi","network","scanner","topology","mapping","tool"],
    href: "https://github.com/josharsh/wifi-radar",
  },
  {
    id: "gh-user-lockbox",
    text: "LockBox: Personal, Safe vault for IOS Built in Swift.",
    category: "project" as const,
    tags: ["lockbox","swift","github","personal","safe","vault"],
    href: "https://github.com/josharsh/LockBox",
  },
  {
    id: "gh-user-lockboxweb",
    text: "LockboxWeb: Web App For LockboxWeb Built in TypeScript.",
    category: "project" as const,
    tags: ["lockboxweb","typescript","github","lockboxweb"],
    href: "https://github.com/josharsh/LockboxWeb",
  },
  {
    id: "gh-user-context-cli",
    text: "context-cli: Ambient Intelligence for Your Terminal",
    category: "project" as const,
    tags: ["context-cli","github","ambient","intelligence","your","terminal"],
    href: "https://github.com/josharsh/context-cli",
  },
  {
    id: "gh-user-document-ai",
    text: "document-ai: Documetn AI (Generic Document Processing) Built in Python.",
    category: "project" as const,
    tags: ["document-ai","python","github","documetn","generic","document","processing"],
    href: "https://github.com/josharsh/document-ai",
  },
  {
    id: "gh-user-go_module",
    text: "go_module: First go moudle",
    category: "project" as const,
    tags: ["go_module","github","first","moudle"],
    href: "https://github.com/josharsh/go_module",
  },
  {
    id: "gh-user-ai-hooks",
    text: "ai-hooks: Custom hooks to integrate ai into your react apps Built in JavaScript.",
    category: "project" as const,
    tags: ["ai-hooks","javascript","github","custom","hooks","integrate","into","your","react"],
    href: "https://github.com/josharsh/ai-hooks",
  },
  {
    id: "gh-user-codewithoutcoffee",
    text: "CodeWithoutCoffee: Say I \"#CodewithoutCoffee\"!",
    category: "project" as const,
    tags: ["codewithoutcoffee","github","open-communication","open-standard","#codewithoutcoffee"],
    href: "https://github.com/josharsh/CodeWithoutCoffee",
  },
  {
    id: "gh-user-ibm-machine-learning-final-project",
    text: "IBM-Machine-Learning-Final-Project: Final Machine Learning Project Submission for Coursera-IBM Machine Learning Course. Built in Jupyter Notebook.",
    category: "project" as const,
    tags: ["ibm-machine-learning-final-project","jupyter notebook","github","coursera","coursera-machine-learning","data-science","ibm","machine-learning","final","machine"],
    href: "https://github.com/josharsh/IBM-Machine-Learning-Final-Project",
  },
  {
    id: "gh-user-lazy-hofs",
    text: "lazy-hofs: Lazy higher order functions in javascript Built in JavaScript.",
    category: "project" as const,
    tags: ["lazy-hofs","javascript","github","lazy","higher","order","functions","javascript"],
    href: "https://github.com/josharsh/lazy-hofs",
  },
  {
    id: "gh-user-factory.js",
    text: "Factory.js: Javascript's native capabilities, expressed as functions. Built in JavaScript.",
    category: "project" as const,
    tags: ["factory.js","javascript","github","javascript","native","capabilities","expressed","functions"],
    href: "https://github.com/josharsh/Factory.js",
  },
  {
    id: "gh-user-stuide",
    text: "Stuide: Android application for students to manage todo(s), notes, timetable and more Built in Java.",
    category: "project" as const,
    tags: ["stuide","java","github","android","application","students","manage","todo","notes"],
    href: "https://github.com/josharsh/Stuide",
  },
  {
    id: "gh-user-react-search",
    text: "React-Search: Submission towards frontend task at Konfhub - Harsh Joshi Built in JavaScript.",
    category: "project" as const,
    tags: ["react-search","javascript","github","submission","towards","frontend","task","konfhub","harsh"],
    href: "https://github.com/josharsh/React-Search",
  },
  {
    id: "gh-user-employee-dashboard",
    text: "Employee-Dashboard: 'Add new Employee' module allows takes bulk csv data as input, validates the input, converts the raw csv dates to human readable format and finally validates the data on the server side before storing it on the database. Built in Pug.",
    category: "project" as const,
    tags: ["employee-dashboard","pug","github","employee","module","allows","takes","bulk","data"],
    href: "https://github.com/josharsh/Employee-Dashboard",
  },
  {
    id: "gh-user-get-movie",
    text: "Get-Movie: Get information about a movie Built in CSS.",
    category: "project" as const,
    tags: ["get-movie","css","github","information","about","movie"],
    href: "https://github.com/josharsh/Get-Movie",
  },
  {
    id: "gh-user-cs-first-web-design",
    text: "CS-First-Web-Design: Web Design resources for CS-First Built in JavaScript.",
    category: "project" as const,
    tags: ["cs-first-web-design","javascript","github","design","resources","cs-first"],
    href: "https://github.com/josharsh/CS-First-Web-Design",
  },
  {
    id: "gh-user-conference-api",
    text: "Conference-API: Towards assignment submission - KonfHub Technologies by Harsh Joshi Built in JavaScript.",
    category: "project" as const,
    tags: ["conference-api","javascript","github","towards","assignment","submission","konfhub","technologies","harsh"],
    href: "https://github.com/josharsh/Conference-API",
  },
  {
    id: "gh-user-atlan-challenge",
    text: "Atlan-Challenge: Submission made towards Atlan Challenge. Built in CSS.",
    category: "project" as const,
    tags: ["atlan-challenge","css","github","submission","made","towards","atlan","challenge"],
    href: "https://github.com/josharsh/Atlan-Challenge",
  },
  {
    id: "gh-user-dice-flutter",
    text: "Dice-Flutter: Basic Flutter application for rolling a dice! ;) Built in Java.",
    category: "project" as const,
    tags: ["dice-flutter","java","github","basic","flutter","application","rolling","dice"],
    href: "https://github.com/josharsh/Dice-Flutter",
  },
  {
    id: "gh-user-opencvlearn",
    text: "OpenCVLearn: Learning OpenCV - Foundations Built in Jupyter Notebook.",
    category: "project" as const,
    tags: ["opencvlearn","jupyter notebook","github","learning","opencv","foundations"],
    href: "https://github.com/josharsh/OpenCVLearn",
  },
  {
    id: "gh-user-deeplearning",
    text: "DeepLearning: My experience with Deep Learning Built in Jupyter Notebook.",
    category: "project" as const,
    tags: ["deeplearning","jupyter notebook","github","experience","with","deep","learning"],
    href: "https://github.com/josharsh/DeepLearning",
  },
  {
    id: "gh-user-calofood",
    text: "CaloFood: Calo is an intelligent android application to monitor vital health aspects and provide analysis on trends .The AI Powered application provides users with cutting edge health aspects while enhancing the user experience using Cloud technology and material design. Built in Java.",
    category: "project" as const,
    tags: ["calofood","java","github","ai","android","androidai","androidapplication","food","java","ocr"],
    href: "https://github.com/josharsh/CaloFood",
  },
  {
    id: "gh-user-technogeek2018",
    text: "TechnoGeek2018: Technogeek is an online quiz website developed using LAMP. It helps to conduct live online quizzes. One can track his submissions, online users and leaderboard. Built in CSS.",
    category: "project" as const,
    tags: ["technogeek2018","css","github","css","html","javascript","mysql-database","php","web","webdevelopment"],
    href: "https://github.com/josharsh/TechnoGeek2018",
  },
  {
    id: "gh-user-docker-guide",
    text: "Docker-Guide: This repository takes you to a journey of learning a DevOps pillar called Docker. Docker has been around since some time now but has been gaining tremendous popularity. UPES-OPEN brings this program to help you get started with learning Docker.",
    category: "project" as const,
    tags: ["docker-guide","github","this","repository","takes","journey","learning","devops"],
    href: "https://github.com/josharsh/Docker-Guide",
  },
  {
    id: "gh-user-androidlabs",
    text: "AndroidLabs: Android Tutorials for Hands on Lab Sessions Built in Java.",
    category: "project" as const,
    tags: ["androidlabs","java","github","android","tutorials","hands","sessions"],
    href: "https://github.com/josharsh/AndroidLabs",
  },
  {
    id: "gh-user-bibliobin",
    text: "BiblioBin: BiblioBin is a book review web app developed using Flask and SQL. You can search for books, leave reviews for individual books, and see the reviews made by other people. Built in HTML.",
    category: "project" as const,
    tags: ["bibliobin","html","github","api","first-timers","flask","heroku","heroku-app","heroku-deployment","heroku-postgres"],
    href: "https://github.com/josharsh/BiblioBin",
  },
  {
    id: "gh-user-learnxml",
    text: "LearnXML: The guide to learning XML",
    category: "project" as const,
    tags: ["learnxml","github","guide","learning"],
    href: "https://github.com/josharsh/LearnXML",
  },
  {
    id: "gh-user-tour-booking-app",
    text: "Tour-Booking-App: A tour booking app, that sells various kinds of tours, and with a lot of other features coming in. Built in HTML.",
    category: "project" as const,
    tags: ["tour-booking-app","html","github","tour","booking","that","sells","various","kinds"],
    href: "https://github.com/josharsh/Tour-Booking-App",
  },
  {
    id: "gh-user-learn-aws-the-oss-way",
    text: "Learn-AWS-the-OSS-way: AWS Learning pathway on many directions is now at a single place.",
    category: "project" as const,
    tags: ["learn-aws-the-oss-way","github","aws","aws-ec2","cloud","cloud-computing","cloudcomputing","oss","learning","pathway"],
    href: "https://github.com/josharsh/Learn-AWS-the-OSS-way",
  },
  {
    id: "gh-user-to-do-form",
    text: "To-Do-Form: This repository contains the assignment work for the Radicali Web development Internship. Built in JavaScript.",
    category: "project" as const,
    tags: ["to-do-form","javascript","github","this","repository","contains","assignment","work","radicali"],
    href: "https://github.com/josharsh/To-Do-Form",
  },
  {
    id: "gh-user-html-templates-using-nodejs",
    text: "HTML-Templates-Using-Nodejs: Node js enables a developer to template HTML web page. Built in HTML.",
    category: "project" as const,
    tags: ["html-templates-using-nodejs","html","github","node","enables","developer","template","html","page"],
    href: "https://github.com/josharsh/HTML-Templates-Using-Nodejs",
  },
  {
    id: "gh-user-pizza-place",
    text: "Pizza-Place: Food-centered project is always a cool idea for a hungry programmer. Pizza-Place is a client-admin application developed on java using swing, database connectivity and core java concepts. Built in Java.",
    category: "project" as const,
    tags: ["pizza-place","java","github","food-centered","project","always","cool","idea","hungry"],
    href: "https://github.com/josharsh/Pizza-Place",
  },
  {
    id: "gh-user-ml-algorithms-python",
    text: "ML-Algorithms-Python: This repository contains implementation of supervised and unsupervised machine learning algorithms implemented in python using Jupyter notebook. Built in Jupyter Notebook.",
    category: "project" as const,
    tags: ["ml-algorithms-python","jupyter notebook","github","this","repository","contains","implementation","supervised","unsupervised"],
    href: "https://github.com/josharsh/ML-Algorithms-Python",
  },
  {
    id: "gh-user-opensourceguide",
    text: "OpenSourceGuide: This repository walks you through the fundamentals of open source contribution from the word go.",
    category: "project" as const,
    tags: ["opensourceguide","github","this","repository","walks","through","fundamentals","open"],
    href: "https://github.com/josharsh/OpenSourceGuide",
  },
  {
    id: "gh-user-java-code-for-live-clock",
    text: "Java-Code-For-Live-Clock: Live Clock is an java-based application which fetches the Live Computer Time.",
    category: "project" as const,
    tags: ["java-code-for-live-clock","github","live","clock","java-based","application","which","fetches"],
    href: "https://github.com/josharsh/Java-Code-For-Live-Clock",
  },
  {
    id: "gh-org-mcp-jest",
    text: "mcp-jest (under the ReallyArtificial org): Automated testing for Model Context Protocol servers. Ship MCP Servers with confidence. Built in TypeScript. 17 ⭐ on GitHub.",
    category: "open-source" as const,
    tags: ["mcp-jest","typescript","github","ai-testing","anthropic","automation","ci-cd","cli","developer-tools","jest"],
    href: "https://github.com/ReallyArtificial/mcp-jest",
  },
  {
    id: "gh-org-engram",
    text: "engram (under the ReallyArtificial org): Agent memory system with retain-recall-reflect loop. Hybrid search, entity resolution, observation synthesis. TypeScript library + MCP server. Built in TypeScript. 2 ⭐ on GitHub.",
    category: "open-source" as const,
    tags: ["engram","typescript","github","agent-memory","agents","ai","ai-agents","ai-infrastructure","embeddings","llm"],
    href: "https://github.com/ReallyArtificial/engram",
  },
  {
    id: "gh-org-freeport",
    text: "freeport (under the ReallyArtificial org): Open-source LLM Gateway. Multi-provider routing, fallback, semantic caching, cost tracking, guardrails. Drop-in OpenAI API replacement. Self-hosted. Built in TypeScript.",
    category: "open-source" as const,
    tags: ["freeport","typescript","github","ai","ai-agents","ai-infrastructure","anthropic","developer-tools","gateway","llm"],
    href: "https://github.com/ReallyArtificial/freeport",
  },
  {
    id: "gh-org-approvalprotocol",
    text: "approvalprotocol (under the ReallyArtificial org): Just an Approval Protocol where humans approve before AI takes an action Built in TypeScript.",
    category: "open-source" as const,
    tags: ["approvalprotocol","typescript","github","just","approval","protocol","where","humans","approve"],
    href: "https://github.com/ReallyArtificial/approvalprotocol",
  },
  {
    id: "gh-org-.github",
    text: ".github (under the ReallyArtificial org): ReallyArtificial org profile and community health files",
    category: "open-source" as const,
    tags: [".github","github","reallyartificial","profile","community","health","files"],
    href: "https://github.com/ReallyArtificial/.github",
  },
  {
    id: "gh-org-manifesto",
    text: "manifesto (under the ReallyArtificial org): The ReallyArtificial manifesto. What it means to be really artificial.",
    category: "open-source" as const,
    tags: ["manifesto","github","ai","ai-agents","ai-infrastructure","humans-and-ai","manifesto","open-source","really-artificial","reallyartificial"],
    href: "https://github.com/ReallyArtificial/manifesto",
  },
];
